var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"expired"}},[_c('img',{attrs:{"src":_vm.imgUrl}}),_c('p',{staticClass:"p1"},[_vm._v("登录超时啦")]),_c('p',{staticClass:"p2"},[_vm._v("请前往大麦系统重新授权登录！")])])}
var staticRenderFns = []

export { render, staticRenderFns }